import { createSlice } from '@reduxjs/toolkit';

const getShortName = (name) => {
  const idx = name.indexOf('(');
  if (idx === -1) {
    return name;
  }
  return name.substring(0, idx-1);
}

export const settingsSlice = createSlice({
  name: 'settings',
  initialState: {
    boardNo: null,
    boardTypes: [],
    gameTypes: [],
  },
  reducers: {
    setBoardNo: (state, action) => {
      state.boardNo = action.payload;
    },
    setBoardTypes: (state, action) => {
      let boardType = null;
      let boardTypes = {};
      for (const t of action.payload) {
        if (boardType === null) {
          boardType = t.id;
        }
        boardTypes[t.id] = t;
      }
      state.boardType = boardType;
      state.boardTypes = boardTypes;
    },
    setGameTypes: (state, action) => {
      let gameType = null;
      let gameTypes = {};
      for (const t of action.payload) {
        if (gameType === null) {
          gameType = t.id;
        }
        if (gameTypes[t.id]) {
          gameTypes[t.id].players.push(t.players);
        } else {
          const shortName = getShortName(t.name);
          gameTypes[t.id] = {id: t.id, name: t.name, shortName: shortName, players: [t.players]};
        }
      }
      state.gameType = gameType;
      state.gameTypes = gameTypes;
    },
  },
});

export const getBoardNo = (state) => state.settings.boardNo;

export const getBoardTypes = (state) => state.settings.boardTypes;

export const getBoardType = (state, id) => state.settings.boardTypes[id] ?? null;

export const getGameTypes = (state) => state.settings.gameTypes;

export const getGameType = (state, id) => state.settings.gameTypes[id] ?? null;

export default settingsSlice.reducer;
